import { Toggle } from '../../atoms/toggle/toggle.js'

class JobRow {
  /**
   * @param root {HTMLElement}
   */
  constructor(root) {
    this.root = root

    this.initialize()
  }

  initialize() {
    // Initialize active/inactive toggle
    this.toggle = new Toggle(this.root.querySelector('[data-sub-component="toggle"]'))
    this.toggle.addEventListener('requestStarted', () => {
      this.loading()
    })
    this.toggle.addEventListener('requestFinished', () => {
      this.loadingFinished()
    })
    this.toggle.addEventListener('toggleError', ev => {
      if (ev instanceof CustomEvent) {
        if (ev.detail.message) {
          this.error(ev.detail.message)
        } else if (ev.detail.url) {
          window.location = ev.detail.url
        }
      } else {
        this.error('Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
      }
    })

    this.deleteDialog = this.root.querySelector('[data-sub-component="deleteDialog"]')
    this.deleteButton = this.root.querySelector('[data-sub-component="deleteButton"]')
    this.deleteConfirm = this.root.querySelector('[data-sub-component="deleteConfirm"]')
    this.deleteCancel = this.root.querySelector('[data-sub-component="deleteCancel"]')
    this.deleteUrl = this.deleteButton.dataset.deleteUrl

    this.deleteButton.addEventListener('click', ev => {
      ev.preventDefault()
      this.deleteDialog.classList.add('is-open')
    })

    this.deleteCancel.addEventListener('click', ev => {
      ev.preventDefault()
      // Stop propagation to not trigger dialog open again
      ev.stopPropagation()
      this.deleteDialog.classList.remove('is-open')
    })

    this.deleteConfirm.addEventListener('click', ev => {
      ev.preventDefault()
      // Stop propagation to not trigger dialog open again
      ev.stopPropagation()
      this.deleteDialog.classList.remove('is-open')
      this.loading()
      fetch(this.deleteUrl, {
        method: 'POST',
        credentials: 'include'
      }).then(response => {
        if (response.status === 200) {
          this.delete()
        } else {
          return response.json().then(data => {
            if (data.message) {
              this.error(data.message)
              this.loadingFinished()
            } else if (data.url) {
              window.location = data.url
            }
          })
        }
      }).catch(() => {
        this.error('Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
        this.loadingFinished()
      }).finally(() => {
      })
    })
  }

  loading() {
    this.clearError()
    this.root.classList.add('is-loading')
  }

  loadingFinished() {
    this.root.classList.remove('is-loading')
  }

  delete() {
    this.loadingFinished()
    // Finish animations to make opacity transition work for deletion
    this.root.getAnimations().forEach(animation => {
      animation.finish()
    })
    this.root.addEventListener('transitionend', ev => {
      if (ev.currentTarget === this.root && ev.propertyName === 'opacity') {
        this.root.remove()
      }
    })
    this.root.classList.add('is-deleted')
  }

  error(message) {
    let error = this.root.querySelector('[data-sub-component="error"]')
    if (!error) {
      error = document.createElement('div')
      error.dataset.subComponent = 'error'
      error.classList.add('job__row', 'mt-0-5', 'job__row--error')
      this.root.appendChild(error)
    }
    error.innerHTML = message
  }

  clearError() {
    const error = this.root.querySelector('[data-sub-component="error"]')
    if (error) {
      error.remove()
    }
  }
}

class Jobs {
  /**
   * @param root {HTMLElement}
   */
  constructor(root) {
    this.root = root

    this.initialize()
  }

  initialize() {
    this.root.querySelectorAll('[data-sub-component="jobRow"]').forEach(row => {
      new JobRow(row) // eslint-disable-line no-new
    })
  }
}

export { Jobs }
